export default class Reason {
  constructor (options = {}) {
    this.id = options.id || null
    this.name = options.name || null
    this.reasonType = options.reason_type || null
    this.locationId = options.location_id || null
    this.doctorId = options.doctor_id || null
    this.appointmentTypeUuid = options.appointment_type_uuid || null
    this.externalReasonId = options.external_reason_id || null
  }
}
